<script setup lang="ts">
import { Icon } from "@/components/Ui";

interface Props {
  isActive?: boolean;
  isWhite?: boolean;
}

const props = defineProps<Props>();
</script>

<template>
  <div :class="{ [toggle.root]: true,  [toggle.white]: props.isWhite, [toggle.active]: props.isActive}">
    <Icon name="menu" :class="toggle.burger" />
    <div :class="toggle.label">
      {{ $t("label.menu") }}
    </div>
    <Icon name="chevron-down" :class="[toggle.chevron, [`rotate-${props.isActive ? 180 : 0}`]]" />
  </div>
</template>

<style lang="scss" module="toggle">
.root {
  @apply flex lg:hidden items-center justify-center cursor-pointer;
  @apply w-10 h-10 xs:h-12 xs:w-12 rounded-[12px];
  @apply bg-black bg-opacity-[0.16] text-neutral-900;
  @apply dark:bg-white dark:bg-opacity-[0.2] dark:text-white;
  @apply transition-all;

  @screen md {
    @apply bg-transparent dark:bg-transparent w-fit h-fit py-[5px] px-[10px] gap-[6px] border border-solid;
    @apply border-neutral-300 dark:border-neutral-800;
    @apply ring-neutral-900 dark:ring-white;
  }
}

.white {
  @apply bg-white/20 text-white;
}

.active {
  @screen md {
    @apply pointer-events-none;
    @apply ring-[1.25px];
    @apply border-neutral-900 dark:border-white;
  }
}

.burger {
  @apply md:hidden w-6 h-6;
}
.chevron,
.label {
  @apply hidden md:block;
}

.chevron {
  @apply w-4 h-4 transform transition-all;
}
</style>